import * as types from 'constants/actionTypes'

const initialState = {}

export default function (state = initialState, action) {
  switch (action.type) {

    case types.SET_INTEGRATION_PRODUCTS:
      const newState = {}
      if (action.products) {
        for (const p of action.products) {
          newState[p.productId] = p
        }
      }
      return newState

    case types.LOGOUT:
      return initialState

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/integrationProducts.js